import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, Loader2Icon } from 'lucide-react';
interface MobileNavProps {
  isOpen: boolean;
  onClose: () => void;
  navItems: Array<{
    id: string;
    label: string;
    icon: React.ElementType;
  }>;
  activeItem: string;
  setActiveItem: (id: string) => void;
  onExport: () => void;
  isExporting: boolean;
}
export const MobileNav: React.FC<MobileNavProps> = ({
  isOpen,
  onClose,
  navItems,
  activeItem,
  setActiveItem,
  onExport,
  isExporting
}) => {
  return <AnimatePresence data-id="element-332">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} className="fixed inset-0 bg-black/30 backdrop-blur-sm md:hidden z-40" data-id="element-333" />
          <motion.div initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        type: 'spring',
        damping: 30,
        stiffness: 300
      }} className="fixed bottom-0 inset-x-0 bg-white rounded-t-2xl shadow-2xl md:hidden z-50" data-id="element-334">
            <div className="relative p-6" data-id="element-335">
              <div className="absolute left-1/2 -translate-x-1/2 -top-3 w-12 h-1.5 bg-gray-300 rounded-full" data-id="element-336" />
              <button onClick={onClose} className="absolute right-5 top-5 p-2 hover:bg-gray-50 rounded-full transition-colors" data-id="element-337">
                <XIcon className="h-5 w-5 text-gray-500" data-id="element-338" />
              </button>
              <nav className="mt-8 space-y-2" data-id="element-339">
                {navItems.map(item => {
              const Icon = item.icon;
              return <button key={item.id} onClick={() => {
                setActiveItem(item.id);
                onClose();
              }} className={`flex items-center w-full px-4 py-3.5 rounded-sm text-sm font-medium transition-all ${activeItem === item.id ? 'bg-[#C00000]/10 text-[#C00000] shadow-sm' : 'text-[#737373] hover:bg-gray-50'}`} data-id="element-340">
                      <Icon className="h-5 w-5 mr-3" data-id="element-341" />
                      {item.label}
                    </button>;
            })}
              </nav>
              <div className="mt-8 space-y-3 px-1" data-id="element-342">
                <button disabled={isExporting} onClick={() => {
              onClose();
              onExport();
            }} className="flex items-center justify-center w-full py-3 space-x-2 bg-white border-2 border-[#C00000] text-[#C00000] rounded-sm font-medium hover:bg-[#C00000]/5 transition-colors disabled:opacity-60 disabled:cursor-not-allowed" data-id="element-343">
                  {isExporting && <Loader2Icon className="h-4 w-4 animate-spin" data-id="element-344" />}
                  <span data-id="element-345">{isExporting ? 'Preparing…' : 'Export report'}</span>
                </button>
                <a href="#" className="flex items-center justify-center w-full py-3 bg-[#0D5C91] text-white rounded-sm font-medium hover:bg-[#0A4A75] transition-colors" onClick={onClose} data-id="element-346">
                  Create new test
                </a>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
};